import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-miscellaneous-receipt',
  templateUrl: './miscellaneous-receipt.component.html',
  styleUrls: ['./miscellaneous-receipt.component.css']
})
export class MiscellaneousReceiptComponent implements OnInit {
  title="Miscellaneous Receipt";

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/chitfund/miscellaneous-receipt/miscellaneous-receipt.component.ts